const Drawer = {
  baseStyle: {
    body: {
      p: 6,
    },
  },
};

export default Drawer;
